export const Download = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 62 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46 24.8916H53.5C55.4891 24.8916 57.3968 25.6782 58.8033 27.0784C60.2098 28.4785 61 30.3775 61 32.3577V71.1812C61 73.1613 60.2098 75.0603 58.8033 76.4605C57.3968 77.8607 55.4891 78.6473 53.5 78.6473H8.5C6.51088 78.6473 4.60322 77.8607 3.1967 76.4605C1.79018 75.0603 1 73.1613 1 71.1812V32.3577C1 30.3775 1.79018 28.4785 3.1967 27.0784C4.60322 25.6782 6.51088 24.8916 8.5 24.8916H16"
        stroke="#465A8C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 42.8096L31 57.7417L46 42.8096"
        stroke="#465A8C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31 1V54.7557"
        stroke="#465A8C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
